const AciAirResponseApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/cusres/get`,
  POST: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/cusres`,
  D4_POST: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/d4notice/post`,
  GET_AUDIT_LOGS: `${process.env.REACT_APP_CNG_ADMIN_ORIGIN_URL}/cng-admin/audit-header/get`
};

export default AciAirResponseApiUrls;
